
import React from "react";
import "./MustardBottleLoader.css";

export default function MustardBottleLoader(props) {
  return (
    <div className="loader-container">
      <div className="mustard-bottle">
        <div className="bottle-neck">
          <div className="mustard-stream"></div>
        </div>
        <div className="bottle-body">
          <div className="label">Loading...</div>
        </div>
      </div>
    </div>
  );
};
